<template>
  <v-layout row wrap mb-0 py-2>
    <v-flex px-4>
      <case-header-new></case-header-new>
    </v-flex>
    <v-flex xs12 px-4 mb-0 v-show="hideInbox">
      <v-btn class="ml-0 mb-3" color="success" @click="addNote"> <v-icon>note</v-icon>&emsp;Add Note </v-btn>
    </v-flex>

    <v-layout colummn>
      <v-flex md9 wrap class="mx-4">
        <v-expansion-panel class="mt-0 notes" expand v-model="panelsExpanded">
          <v-expansion-panel-content v-for="(note, i) in notes" :key="i" hide-actions>
            <template v-slot:header>
              <CaseNoteHeader :id="getNoteIndex(i)" :noteIndex="i" :note="note" :userPreferences="userPreferences" :editing="note.editing" v-slot:header></CaseNoteHeader>
            </template>
            <CaseNote :noteIndex="i" :note="note" :currentUser="currentUser" :editing="note.editing"></CaseNote>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      <v-flex md3 px-2 mb-0 style="position: relative" class="hidden-sm-and-down" v-if="showJumpToMenu">
        <v-flex xs12 px-0 class="rounded-3">
          <div class="caption opacity-54 mb-1 text-uppercase primary--text">
            <PageTitle pageTitle="Jump to a note"></PageTitle>
          </div>
          <v-divider class="mb-0"></v-divider>
        </v-flex>
        <case-menu id="case-notes-menu" :caseMenuItems="caseMenuItems" :caseIsLoading="caseIsLoading" :hasPermissionToSave="hasPermissionToSave"></case-menu>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import Vue from "vue"
import PageTitle from "@/components/PageTitle.vue"
import CaseMenu from "@/components/cases/case-edit/CaseMenu"
import CaseHeaderNew from "@/components/cases/case-edit/CaseHeaderNew.vue"
import CaseNoteHeader from "@/components/cases/case-edit/CaseNoteHeader.vue"
import CaseNote from "@/components/cases/case-edit/CaseNote.vue"
import { mapState } from "vuex"
import Helpers from "@/helpers.js"

export default {
  name: "case-notes",
  components: { CaseHeaderNew, CaseNote, PageTitle, CaseMenu, CaseNoteHeader },
  data: () => ({
    hideInbox: true,
    showEmailChain: false,
    currentEmailChain: {},
    documentsMenu: false,
    documentsMenuReply: false,
    composeDialog: false,
    selectedMultipleChips: "",
    selectedMultipleChipsReply: [],
    composeMinified: false,
    caseIsLoading: false,
    hasPermissionToSave: false,
  }),
  computed: {
    ...mapState({
      currentCase: (state) => state.cases.currentlySelected.case,
      notes: (state) => state.cases.currentlySelected.case.notes,
      currentUser: (state) => state.currentUser.me,
      userPreferences: (state) => state.currentUser.me.preferences,
      showJumpToMenu: (state) => state.ui.keepMainMenuExpanded,
    }),

    panelsExpanded() {
      if (this.notes) {
        return this.notes.map(() => true)
      } else {
        return []
      }
    },

    caseMenuItems() {
      if (this.notes && this.notes.length > 0) {
        let idx = 0
        return this.notes.map((n) => ({
          subject: n.subject,
          id: `note-${idx++}`,
        }))
      } else {
        return []
      }
    },
  },
  methods: {
    getNoteIndex(i) {
      return `note-${i}`
    },
    addNote() {
      this.$store.dispatch("addCaseNote", this.currentUser)
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight)
      }, 500)
    },
    formatDate(date) {
      if (this.userPreferences.dateTimeFormat) {
        return Helpers.formatDate(date, this.userPreferences.dateTimeFormat)
      } else {
        return Helpers.formatDate(date, "Do MMM YYYY HH:mm")
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    const state = Vue.store.state
    const currentUser = Object.assign(state.currentUser.me, {
      account: { id: state.currentUser.account.id },
    })
    Vue.store.dispatch("unsubscribeToCaseChannelV2", {
      caseId: from.params.case_id,
      currentUser: currentUser,
    })
    next()
  },
  beforeRouteEnter(to, from, next) {
    const state = Vue.store.state
    const currentUser = Object.assign(state.currentUser.me, {
      account: { id: state.currentUser.account.id },
    })
    Vue.store.dispatch("subscribeToCaseChannelV2", {
      caseId: to.params.case_id,
      currentUser,
    })
    next()
  },
}
</script>

<style>
.v-expansion-panel.notes {
  box-shadow: none;
  border-bottom: 1px solid rgba(192, 192, 192, 1);
}

.v-expansion-panel.notes .v-expansion-panel__container {
  background: none !important;
  margin: 0 0 -1px 0;
}

.v-expansion-panel.notes .v-expansion-panel__header {
  padding: 0 !important;
  transition: all 0.2s;
  border-top: 1px solid rgba(192, 192, 192, 1);
}
.v-expansion-panel.notes .v-expansion-panel__header .editing {
  opacity: 0.35;
}

.v-expansion-panel.notes .v-expansion-panel__container--active {
  margin: 0 0 20px 0;
  transition: all 0.2s;
}

.v-expansion-panel.notes .v-expansion-panel__container--active .v-expansion-panel__header {
  background: white;
  border-bottom: none;
  transition: all 0.2s;
}

.v-expansion-panel.notes .v-expansion-panel__container--active {
  webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
}

.note-actions {
  position: absolute;
  right: 0;
  top: 6px;
  width: 240px;
  text-align: right;
}

.note-header-left {
  width: 100%;
  position: relative;
  padding: 0 260px 0 0;
}

.note-header-left .v-text-field {
  width: 100%;
  padding: 0 0 0 40px;
}
.note-header-left .v-text-field .v-input__slot {
  -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0);
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0) !important;
  background: rgba(0, 0, 0, 0.06) !important;
  margin-bottom: 0;
}

.note-header-left h3 {
  padding: 12px 0 12px 40px !important;
}

.note-avatar {
  position: absolute;
  left: 0px;
  top: 10px;
}
</style>
